import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import SpecialistPageForm from "./SpecialistPageForm";

const AddSpecialistPage = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Add_SpecialistPage_Modal, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addStaticPage"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_SpecialistPage_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_SpecialistPage_Modal ? Add_SpecialistPage_Modal : false}
      width={500}
      form={form}
      recordName="specialistPageList"
      extraFieldName="portal"
      extraFieldValue="specialist"
    >
      <SpecialistPageForm />
    </FormModal>
  );
};

export default AddSpecialistPage;
